import { Link } from "wouter";
import { EmptyState } from "../components/AsyncStates";
import { Button } from "../components/Button";

export function NotFoundPage() {
  return (
    <EmptyState
      title="Page not found"
      description="That page doesn't exist, or you don't have access to it."
      action={
        <Link to="/containers">
          <Button variant="secondary">Back to containers</Button>
        </Link>
      }
    />
  );
}
